import React from 'react';

/**
 * PremiumButton - Boutons standardisés avec style premium
 */
const PremiumButton = ({ 
  children, 
  onClick,
  variant = 'primary', // 'primary' | 'secondary' | 'ghost'
  size = 'md', // 'sm' | 'md' | 'lg'
  fullWidth = false,
  disabled = false,
  className = '',
  icon = null,
  ...props
}) => {
  const baseClasses = 'font-semibold transition-all duration-200 flex items-center justify-center gap-2';
  
  const variantClasses = {
    primary: `
      bg-gradient-to-r from-[#6A4FFF] to-[#9f86ff] 
      text-white 
      rounded-xl 
      active:scale-95 
      hover:scale-100
      disabled:opacity-50 
      disabled:cursor-not-allowed
    `,
    secondary: `
      bg-white/[0.06] 
      border border-white/[0.1] 
      text-white/80 
      rounded-xl 
      hover:bg-white/10 
      active:scale-95
      disabled:opacity-50 
      disabled:cursor-not-allowed
    `,
    ghost: `
      text-white/70 
      hover:text-white 
      hover:bg-white/5 
      rounded-xl 
      active:scale-95
      disabled:opacity-50 
      disabled:cursor-not-allowed
    `
  };
  
  const sizeClasses = {
    sm: 'py-2 px-4 text-sm',
    md: 'py-3 px-6 text-base',
    lg: 'py-4 px-8 text-lg'
  };
  
  const widthClass = fullWidth ? 'w-full' : '';
  
  const shadowStyle = variant === 'primary' && !disabled 
    ? { boxShadow: '0 0 20px rgba(106, 79, 255, 0.4)' }
    : {};

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        ${baseClasses}
        ${variantClasses[variant]}
        ${sizeClasses[size]}
        ${widthClass}
        ${className}
      `}
      style={shadowStyle}
      {...props}
    >
      {icon && <span className="flex-shrink-0">{icon}</span>}
      {children}
    </button>
  );
};

export default PremiumButton;
